module.exports = __webpack_public_path__ + "static/media/BQCHENGZI_MENU_DESKTOP.417654cc.jpg";